const Routes = {
  root: "/",
  auth: "/auth",
  visualizer: "/visualizer",
  home: "/home",
  view: "/view/:id",
};

export default Routes;
